









































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import TextBasic from '@/components/text/basic.vue';

@Component({
  components: {
    TextBasic,
  },
  props: ['isPage'],
})
export default class BoxNumber extends Vue {

  /**
   * カウンターオブジェクト
   */
  public counter1: any = {
    num0: '',
    num10: '',
  };

  /**
   * カウンター
   */
  public counter2: any = {
    num0: '',
    num10: '',
    num100: '',
    dot: false,
  };

  /**
   * カウンターオブジェクト
   */
  public counter3: any = {
    num0: '',
    num10: '',
    num100: '',
    dot: false,
  };

  /**
   * カウントアップ
   */
  public countUp(): void {
    setTimeout((): void => {
      this.count1(this.counter1, 0, parseInt((this.$refs.count1 as any).getAttribute('data-count'), 10), 1)
      .then((): void => {
        setTimeout((): void => {
          this.count1(this.counter2, 0, parseInt((this.$refs.count2 as any).getAttribute('data-count'), 10), 1)
          .then((): void => {
            setTimeout((): void => {
              this.count1(this.counter3, 0, parseInt((this.$refs.count3 as any).getAttribute('data-count'), 10), 1);
            }, 100);
            this.counter3.dot = true;
          });
        }, 100);
        this.counter2.dot = true;
      });
    }, 500);
  }

  /**
   * カウンター実行
   */
  private count1(counter: any, start: number, end: number, speed: number): Promise<any> {
    return new Promise((resolve: any, reject: any): any => {
      const intervalId: any = setInterval((): void => {
        if (! counter) {
          clearInterval(intervalId);
          resolve();
        }

        const num: any = start.toString().split('');
        if (num.length === 3) {
          counter.num0 = num[2] ? num[2] : '';
          counter.num10 = num[1] ? num[1] : '';
          counter.num100 = num[0] ? num[0] : '';
        } else if (num.length === 2) {
          counter.num0 = num[1] ? num[1] : '';
          counter.num10 = num[0] ? num[0] : '';
        }
        start++;

        if (start > end) {
          clearInterval(intervalId);
          resolve();
        }
      }, speed);
    });
  }

  /**
   * カウンター実行
   */
  private count2(counter: any, start: number, end: number): Promise<any> {
    return new Promise((resolve: any, reject: any): any => {
      const intervalId: any = setInterval((): void => {
        if (! counter) {
          clearInterval(intervalId);
          resolve();
        }

        counter.num = start;
        start++;

        if (start > end) {
          clearInterval(intervalId);
          resolve();
        }
      }, 100);
    });
  }

}
